export const UNPROCESSABLE_ENTITY_STATUS_CODE = 422;
export const UNPROCESSABLE_ENTITY_MESSAGE = 'Request failed with status code 422';
export const CREATED_STATUS_CODE = 201;
export const OK_STATUS_CODE = 200;
export const SOMETHING_WENT_WRONG_MESSAGE = 'Hmmm… It seems like something went wrong. Please try again.';
